import fotoElectronica1 from "../components/campus_electronica1.png";
import puzzle from "../components/puzzle.PNG";
import ia from "../components/IA.PNG";
import cyber from "../components/cyber.png";


export default function Menu2() {
  return (
    <div style={{ padding: 20, maxWidth: 900, margin: "0 auto", lineHeight: 1.7 }}>
      <h2 style={{ 
  marginBottom: 24, 
  textAlign: "center", 
  fontSize: 36, 
  fontWeight: 700, 
  letterSpacing: 2, 
  textTransform: "uppercase",
  borderBottom: "3px solid #2563eb",
  paddingBottom: 12,
  color: "#2563eb"
}}>
  CAMPUS M3
</h2>

      <p>
        En M3 cada campus está diseñado para despertar la curiosidad, motivar el
        aprendizaje y acercar a niños y adolescentes a las tecnologías que
        marcarán su futuro. Cada programa está adaptado a la edad del alumno,
        combinando teoría, práctica y una metodología dinámica para que aprender
        resulte útil, entretenido y estimulante.
      </p>

      <h3 style={{ marginTop: 32 }}>Campus de Electrónica | Niños de 8 a 12 años Turno de mañana (9:30-13:30)</h3>
      <p>
        Un campus práctico y creativo para que los niños descubran cómo funciona
        la tecnología que utilizan en el día a día. Es de gran importancia que los niños entiendan que ellos mismos
        pueden crear tecnología con pocos materiales y que no supone grandes esfuerzos. <br />
        Horario:  <br />
        - <strong>(9:30-10:15) ELECTRICIDAD BÁSICA </strong><br />
        Aprenderán electricidad básica, comprenderán los conceptos de Intensidad, Voltaje y Resistencia
         mediante experimentos visuales.<br />
         -<strong>(10:15-11:10) ELECTRÓNICA Y PROGRAMACIÓN BÁSICA </strong><br />
         Empezaremos con introducción a la robótica y como se producen las entradas y salidas
         necesarias para materializar proyectos. Se verán conceptos de programación, donde los propios niños
         podrán ejecutar sus propios algoritmos de programación a través de la programación con piezas
         de puzzle en Scratch. Afianzaremos conocimientos realizando concurso de conocimientos en kahoot. <br />
         -<strong>(11:10-11:40) DESCANSO.</strong><br /> Es recomendable que los niños traigan una mochila pequeña con almuerzo y agua para tomar
         en el descanso, durante este parón los niños estarán en todo momento atendidos por un monitor.<br />
         -<strong>(11:40-12:20) PLACAS DE DESARROLLO </strong><br /> 
         Vuelta al aula. Se hará una introducción a Arduino NANO, programación y usos. <br />
         -<strong>(12:20-13:30) PRÁCTICA DEL CAMPUS </strong><br /> 
          Construiremos un coche robot que se mueve aproximándole la mano cerca de el. 
         Finalizaremos el Campus con entrega de diploma M3Campus. <br />  
         <br />
         Todas las Actividades eléctricas son complematemente seguras, ya que, solo se usan pilas comunes
         como las que se pueden encontrar por casa. Lon niños estarán atendidos en todo momento por monitor.
         Si tiene alguna duda o consulta, no dude en ponerse en contacto con nuestro equipo.  <br />  
        
      </p>

      <img src={fotoElectronica1} alt="Campus de Electrónica" style={{width: "100%", maxWidth: 300, display: "block", margin: "16px auto", borderRadius: 8}} />

      <h3 style={{ marginTop: 32 }}>Campus de Electrónica | Niños de 8 a 12 años Turno de tarde (16:30-20:30)</h3>
      <p>
        Un campus práctico y creativo para que los niños descubran cómo funciona
        la tecnología que utilizan en el día a día. Es de gran importancia que los niños entiendan que ellos mismos
        pueden crear tecnología con pocos materiales y que no supone grandes esfuerzos. <br />
        Horario:  <br />
        - <strong>(16:30-17:15) ELECTRICIDAD BÁSICA </strong><br /> Aprenderán electricidad básica, comprenderán los conceptos de Intensidad, Voltaje y Resistencia
         mediante experimentos visuales.<br />
         -<strong>(17:15-18:10) ELECTRÓNICA Y PROGRAMACIÓN BÁSICA </strong><br /> Empezaremos con introducción a la robótica y como se producen las entradas y salidas
         necesarias para materializar proyectos. Se verán conceptos de programación, donde los propios niños
         podrán ejecutar sus propios algoritmos de programación a través de la programación con piezas
         de puzzle en Scratch. Afianzaremos conocimientos realizando concurso de conocimientos en kahoot. <br />
         -<strong>(18:10-18:40) DESCANSO.</strong><br /> Es recomendable que los niños traigan una mochila pequeña con merienda y agua para tomar
         en el descanso, durante este parón los niños estarán en todo momento atendidos por un monitor.<br />
         -<strong>(18:40-19:20) PLACAS DE DESARROLLO </strong><br />  Vuelta al aula. Se hará una introducción a Arduino NANO, programación y usos. <br />
         -<strong>(12:20-13:30) PRÁCTICA DEL CAMPUS </strong><br /> Construiremos un coche robot que se mueve aproximándole la mano cerca de el. 
         Finalizaremos el Campus con entrega de diploma M3Campus. <br />  
         <br />
         Todas las Actividades eléctricas son complematemente seguras, ya que, solo se usan pilas comunes
         como las que se pueden encontrar por casa. Lon niños estarán atendidos en todo momento por monitor.
         Si tiene alguna duda o consulta, no dude en ponerse en contacto con nuestro equipo.  <br />  
        
      </p>
        <img src={puzzle} alt="puzzle" style={{width: "100%", maxWidth: 400, display: "block", margin: "16px auto", borderRadius: 8}} />

      <h3 style={{ marginTop: 32 }}>
        Campus de Inteligencia Artificial | Niños de 8 a 12 años
      </h3>
      <p>
        Una introducción adaptada a su edad al mundo de la inteligencia
        artificial. Los alumnos descubrirán qué es realmente una IA, cómo
        aprende, para qué sirve y cómo está cambiando el mundo que les rodea. A
        través de ejemplos visuales, ejercicios creativos y actividades
        prácticas, empezarán a comprender conceptos que marcarán el futuro,
        despertando su curiosidad por una de las tecnologías más revolucionarias
        de nuestro tiempo. De la misma manera, aprenderán a hacer uso de la IA de una forma racional y
        óptima ayudando en sus tareas del día a día, alcanzando una mayor productividad. <br />
        - <strong>¿Qué es la Inteligencia Artificial?</strong><br />

          Descubrimos qué significa que una máquina pueda "pensar", cómo aprende y en qué se diferencia de un programa normal.<br />
         -<strong> El combustible de la IA: los datos </strong><br />

          La IA aprende leyendo millones de ejemplos. Entendemos qué son los datos, cómo se recopilan y por qué son tan valiosos. <br />
          - <strong>Máquinas que aprenden solas</strong><br />

          Los modelos de machine learning aprenden de ejemplos sin que nadie les dé instrucciones paso a paso. ¡Como tú cuando aprendes a montar en bici!<br /> 
          - <strong>Cómo entiende el texto la IA: tokens y LLMs</strong><br />

            Los grandes modelos de lenguaje (LLMs) leen y generan texto dividiéndolo en pequeños trozos llamados tokens. Así es como ChatGPT o Claude pueden "hablar".<br />

          - <strong>Muchas IAs, muchos superpoderes </strong><br />

            No todas las IAs hacen lo mismo: hay IAs que ven imágenes, otras que generan música, otras que juegan a videojuegos o conducen coches. <br /> 

           - <strong>IA responsable: ¿puede equivocarse?</strong><br /> 

            Las IAs no son perfectas y pueden cometer errores o ser injustas. Aprendemos a usarlas con responsabilidad y a pensar críticamente sobre sus respuestas.<br /> 
           - <strong>¡Crea tu propio asistente con IA!</strong><br />

            Ponemos en práctica todo lo aprendido diseñando y probando un asistente o proyecto propio usando herramientas de IA accesibles.<br />
      </p>

      <img src={ia} alt="ia" style={{width: "100%", maxWidth: 400, display: "block", margin: "16px auto", borderRadius: 8}} />

      <h3 style={{ marginTop: 32 }}>Campus de Ciberseguridad | Niños de 8 a 12 años Turno de tarde (16:30-20:30)</h3>
      <p>
        Un primer contacto con la seguridad digital desde una perspectiva clara,
        útil y cercana. Los niños aprenderán a proteger su información,
        entenderán los riesgos de internet y conocerán la importancia de las
        contraseñas, la privacidad y el uso responsable de la tecnología. El
        objetivo es que desarrollen desde pequeños una mentalidad de seguridad y
        sepan moverse con mayor confianza en un entorno cada vez más digital. <br />
        Horario: <br />
        - <strong> INTERNET Y CÓMO FUNCIONA </strong><br /> Aprenderán qué es internet por dentro, cómo viaja la información y qué
        significa que algo sea "público" o "privado" en la red. Realizarán experimentos visuales para
        entender conceptos como dirección IP, servidores y navegadores. <br />
        - <strong> CONTRASEÑAS, IDENTIDAD DIGITAL Y AMENAZAS </strong><br /> Descubrirán cómo crear contraseñas seguras y por qué es tan importante no compartirlas.
        Conocerán los principales peligros de internet: phishing, malware y engaños online. Los niños
        podrán poner en práctica lo aprendido a través de dinámicas interactivas y un concurso de
        conocimientos en Kahoot. <br />
        - <strong> DESCANSO.</strong><br /> Es recomendable que los niños traigan una mochila pequeña con merienda y agua para tomar
        en el descanso, durante este parón los niños estarán en todo momento atendidos por un monitor. <br />
        - <strong> PRIVACIDAD Y REDES SOCIALES </strong><br /> Vuelta al aula. Analizaremos qué información compartimos sin darnos cuenta en redes sociales
        y aplicaciones. Aprenderán a configurar la privacidad de sus cuentas y a distinguir
        contenido fiable de contenido falso (fake news). <br />
        - <strong> PRÁCTICA DEL CAMPUS </strong><br /> Construiremos nuestro propio "escudo digital": cada niño diseñará su plan personal de
        seguridad en internet. Realizaremos un reto final de ciberseguridad en equipo y
        finalizaremos el Campus con entrega de diploma M3Campus. <br />
        <br />
        Todas las actividades son completamente seguras y adaptadas a la edad, utilizando herramientas
        y simulaciones diseñadas para entornos educativos. Los niños estarán atendidos en todo momento
        por un monitor. Si tiene alguna duda o consulta, no dude en ponerse en contacto con nuestro equipo. <br />
      </p>

      <img src={cyber} alt="cyber" style={{width: "100%", maxWidth: 400, display: "block", margin: "16px auto", borderRadius: 8}} />

      <h3 style={{ marginTop: 32 }}>
        Campus de Inteligencia Artificial | Adolescentes
      </h3>
      <p>
        Un campus orientado a jóvenes que quieren ir un paso más allá y
        comprender la inteligencia artificial de forma más profunda. Aquí no
        solo verán aplicaciones prácticas, sino también los fundamentos que hay
        detrás: cómo se entrenan modelos, qué limitaciones tienen, cómo
        influyen los datos y por qué la IA será una herramienta clave en el
        futuro profesional. Todo ello desde una perspectiva accesible, moderna y
        adaptada a su nivel.<br /> 
         <strong>EN DESARROLLO...</strong><br /> 
      </p>

      <h3 style={{ marginTop: 32 }}>
        Campus de Ciberseguridad | Adolescentes
      </h3>
      <p>
        Un campus diseñado para introducir a los adolescentes en uno de los
        ámbitos con más proyección de futuro. Aprenderán conceptos clave sobre
        protección de sistemas, privacidad, amenazas digitales, buenas
        prácticas de seguridad y funcionamiento básico de los ataques más
        comunes. Más allá de la teoría, adquirirán una forma de pensar crítica y
        analítica que les permitirá entender mejor el entorno digital y
        protegerse en él. <br />
         <strong>EN DESARROLLO...</strong><br />
      </p>


      <p style={{ fontWeight: "bold", marginTop: 28 }}>
        Cada campus de M3 nace con un mismo propósito: enseñar tecnología desde
        la base, adaptada a cada edad y enfocada a despertar interés real por
        aprender, construir y comprender el mundo del mañana.
      </p>
    </div>
  );
}